export default "__VITE_ASSET__TSsF_pt5__"